









import CFormError from '~/components/shared/configurable/form/CFormError.vue'

export default {
  components: { CFormError },
  props: {
    error: {
      type: [String, Error],
      default: null
    }
  }
}
